import http from "../../backend/http.js";
import moment from "moment";

async function getProjects(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = ""
) {
  try {
    const response = await http.get(
      `projects/v2?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function getProject(id) {
  try {
    const response = await http.get(`projects/v2/${id}`);
    return {
      id: response.data.id,
      title: response.data.title,
      description: response.data.description,
      date: moment(response.data.date).format("DD.MM.YY"),
      LogWorks: response.data.logWorks,
    };
  } catch (err) {
    throw err;
  }
}

async function createProject(project) {
  try {
    const response = await http.post("projects/v2", project);
    return response;
  } catch (err) {
    throw err;
  }
}

async function updateProject(id, project) {
  try {
    await http.put(`projects/v2/${id}`, project);
  } catch (err) {
    throw err;
  }
}

async function getProjectReferences(page = 1, rowsPerPage = 9, search = "") {
  try {
    const response = await http.get("projects/v2/references", {
      params: {
        page,
        pageSize: rowsPerPage,
        searchTerm: search,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

export { getProjects, getProject, createProject, updateProject, getProjectReferences };

